import { Component, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@sb/ui/button';
import { clsx } from 'clsx';

@Component({
  selector: 'sb-support-checklist-widget',
  templateUrl: './sb-support-checklist-widget.component.html',
  imports: [ButtonComponent, TranslatePipe],
  host: {
    '[class]': 'hostClass',
  },
})
export class SbSupportChecklistWidgetComponent {
  hostClass = clsx('flex flex-col items-start justify-start gap-sm');

  getStarted = output<void>();
}
